import { Pipe, PipeTransform } from '@angular/core';
import { StoryDate } from '../model/story/story-date.model';

@Pipe({
    name: 'storyDate',
    standalone: true
})
export class StoryDatePipe implements PipeTransform {
    transform(value: string | null | undefined): string | null {
        if (!value) {
            return null;
        }

        const storyDate = StoryDate.crateFromString(value);
        return storyDate.toTemplateString();
    }
}
